import { NavLink, Outlet, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { LayoutDashboard, Inbox, FileText, BookOpen, Calendar, Mail, Settings, LogOut, Package, ShoppingBag, Users } from "lucide-react";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/orders", label: "Siparişler", icon: ShoppingBag },
  { to: "/admin/products", label: "Ürünler", icon: Package },
  { to: "/admin/users", label: "Kullanıcılar", icon: Users },
  { to: "/admin/leads", label: "Lead'ler", icon: Inbox },
  { to: "/admin/content", label: "İçerik (CMS)", icon: FileText },
  { to: "/admin/programs", label: "Programlar", icon: BookOpen },
  { to: "/admin/events", label: "Atölye Etkinlikleri", icon: Calendar },
  { to: "/admin/newsletter", label: "Bilgece Mektup", icon: Mail },
  { to: "/admin/settings", label: "Site Ayarları", icon: Settings },
];

export function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center bg-brand-green text-brand-offwhite">Yükleniyor…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

export default function AdminLayout() {
  const { logout, user } = useAuth();
  const nav = useNavigate();

  return (
    <div className="min-h-screen flex bg-brand-cream">
      <aside className="w-64 bg-brand-green text-brand-offwhite flex flex-col fixed inset-y-0 left-0">
        <div className="p-6 border-b border-brand-offwhite/10">
          <div className="font-serif text-2xl font-semibold">BİLGECE<span className="text-brand-gold align-super text-sm">™</span></div>
          <p className="text-brand-offwhite/50 text-xs mt-1">Yönetim Paneli</p>
        </div>
        <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
          {NAV.map((n) => {
            const Icon = n.icon;
            return (
              <NavLink key={n.to} to={n.to} end={n.end} data-testid={`admin-nav-${n.label}`}
                className={({ isActive }) => `flex items-center gap-3 px-4 py-2.5 rounded-sm text-sm transition-colors ${
                  isActive ? "bg-brand-gold text-brand-offwhite" : "text-brand-offwhite/70 hover:bg-brand-green2"
                }`}>
                <Icon size={18} /> {n.label}
              </NavLink>
            );
          })}
        </nav>
        <div className="p-4 border-t border-brand-offwhite/10">
          <p className="text-xs text-brand-offwhite/50 mb-2 px-2 truncate">{user?.email}</p>
          <button onClick={() => { logout(); nav("/admin/login"); }} data-testid="admin-logout"
            className="flex items-center gap-3 px-4 py-2.5 rounded-sm text-sm text-brand-offwhite/70 hover:bg-brand-green2 w-full">
            <LogOut size={18} /> Çıkış Yap
          </button>
        </div>
      </aside>
      <main className="flex-1 ml-64 p-8 lg:p-12 overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
